export default __webpack_public_path__ + "static/media/azure_gray.4a0ea5e4.svg";